import { agentCard, applyOverrides } from '../../../shared';

export const buyersAgentCard = applyOverrides(agentCard, {
  id: 'buySideContacts.buyersAgent',
  innerTitle: "Tenant's Agent x",
  outerTitle: "Tenant's Agents",
  addableTitle: "Tenant's Agent x",
  addText: "Tenant's Agent",
});
